module.exports = __webpack_public_path__ + "amcharts/images/dragIconRoundBig.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRoundBig.svg
// module id = 247
// module chunks = 0